import styled from 'styled-components';

import { ErrorBanner } from 'ui/banner';
import { BasicSelect } from 'ui/selects';
import { spacing, Subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const CheckUsersWrapper = styled.div``;

export const CheckUsersRow = styled.div`
  display: flex;
  align-items: stretch;
  margin-bottom: ${spacing.half};
  flex-wrap: nowrap;
`;

export const CheckUsersOptionsWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  gap: ${spacing.half};
  margin-right: ${pxToRem(48)};
`;

export const CheckUsersResultWrapper = styled.div`
  max-width: ${pxToRem(88)};
  flex: 0 0 ${pxToRem(88)};
`;

export const CheckUsersHeader = styled(Subtitle2)`
  margin-bottom: 0;
`;

export const IdTypeSelect = styled(BasicSelect)`
  width: ${pxToRem(123)};
`;

export const SplitTestErrorBanner = styled(ErrorBanner)`
  margin-bottom: ${spacing.base};
`;
